import React from 'react';
import { Logo } from '../logo/logo';

export const Footer = () => {
  return (
    <footer className="bg-plt-bg pt-12 pb-12">
      <div className="w-fit mx-auto">
        <Logo />
      </div>
      <p className="text-center max-w-[1022px] mx-auto mt-9 text-plt-white leading-[120%] font-gilroy">
        Продолжая использовать наш сайт и отправляя любую форму на сайте, Вы
        даете согласие на обработку файлов Cookies и других пользовательских
        данных, в соответствии с 
        <a className="underline" href="/assets/doc/Politika-konf_futurist.doc">
          политикой конфиденциальности
        </a>
        , а также соглашаетесь на получение рассылки на электронную почту,
        указанную в заявке. Запретить обработку Cookies можно в настройках
        Вашего браузера.
      </p>
    </footer>
  );
};
